// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("jquery")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("chart.js")
window.bulmaCarousel = require("bulma-carousel")

window.chartColors = {
    "eolica": "#79AC15",
    "hidrica": "#29461C",
    "cogeracao": "#0064AA",
    "geotermia": "#3FADA7",
    "outras": "#E9A100",
    "residuos_solidos": "#E54925",
    "cogeracao_fossil": "#D9237B",
    "gas": "#4B297C",
    "diesel": "#AeAEAD",
    "fueloleo": "#4D4D4D",
    "nuclear": "#040405",
    "carvao": "rgb(102,51,4)",
}

window.charts = [];

var img = new Image();
img.src = "/images/icon-ree.svg";

Chart.plugins.register({
    beforeDraw: function(chartInstance) {
      var ctx = chartInstance.chart.ctx;
      ctx.fillStyle = "rgb(227,158,38)";
      ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
      //ctx.drawImage(img, 0, 0);

      var size = 150;

      var x =chartInstance.chart.width / 2 - size / 2;
      var y =chartInstance.chart.height / 2 - size / 2;
      ctx.drawImage(img,x,y,size,size);
    }
});

function get_chart_index(event) {
    if (event.target.id == "chart-area") {
        return [0, 1];
    } else {
        return [1, 0];
    }
}

chart_click_event = function (event, array) {
    if (event === 'undefined' || event == null) {
        return;
    }
    if (array.length <= 0) {
        return;
    }

    var indexes = get_chart_index(event, array);
    var chart_index = indexes[0];
    var other_index = indexes[1];
    var chart = window.charts[chart_index];
    var active = chart.getElementAtEvent(event);
    if (active === 'undefined' || active == null || active.length === 0) {
        return;
    }

    var chart = active[0];
    var chartData = chart['_chart'].config.data;
    var idx = chart['_index'];
    var label = chartData.labels[idx];
    var value = chartData.datasets[0].data[idx];

    $('.legend-label').html(label);

    var legend_values = $('.legend-value');

    var legend_value = $(legend_values[chart_index]);
    var other_legend_value = $(legend_values[other_index]);
    if (other_legend_value.length > 0) {
        var other_value = window.charts[other_index].config.data.datasets[0].data[idx];
        other_legend_value.html(other_value + "%");
    }

    legend_values.removeClass(function (index, className) {
        return (className.match(/(^|\s)color-\S+/g) || []).join(' ');
    });

    var color_class = "color-" + I18n_inv[label];
    legend_values.addClass(color_class);

    legend_value.html(value + "%");

}

create_chart = function (offer, elementid) {

    var chart_area = document.getElementById(elementid);
    if (chart_area != null) {
        labels = [];
        data = [];
        colors = [];

        var chart_keys = Object.keys(window.chartColors);

        for (let i = 0; i < chart_keys.length; i++) {
            x = chart_keys[i];
            if (offer[x] > 0) {
                var i18n_label = I18n[x] || x;
                labels.push(i18n_label);
                data.push((offer[x] * 100).toFixed(2));
                colors.push(window.chartColors[x]);
            }
        }

        var ctx = chart_area.getContext('2d');
        var config = {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: colors,
                    borderWidth: 1,
                    hoverBorderWidth: 4,
                }],
                labels: labels,
            },

            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    position: 'right',
                    color: "white",
                    display: false
                },
                title: {
                    display: false
                },
                animation: {
                    animateScale: animate_chart,
                    animateRotate: animate_chart,
                    duration: 1000,
                    easing: "easeInOutCubic"
                },
                display: true,
                lineWidth: "10px",
                layout: {
                    padding: {
                        left: 25,
                        right: 25,
                        top: 25,
                        bottom: 25
                    }
                },
                segmentShowStroke: false,
                onClick: chart_click_event,
                onHover: chart_click_event,
            }
        };

        window.charts.push(new Chart(ctx, config));
    }
}

function beforePrint() {
    for (const id in Chart.instances) {
        Chart.instances[id].resize()
    }
}

if (window.matchMedia) {
    var wait = true;
    let mediaQueryList = window.matchMedia('print')
    mediaQueryList.addListener((mql) => {
        if (mql.matches ){//&& !(typeof(avoid_beforeprint) != "undefined" && avoid_beforeprint == true)) {
           beforePrint()
        }
    })
}

function resizeText(multiplier) {
    if (document.body.style.fontSize == "") {
      document.body.style.fontSize = "1.0em";
    }
    document.body.style.fontSize = parseFloat(document.body.style.fontSize) + (multiplier * 0.2) + "em";
}

var bootInit = function () {
    if (typeof offer !== 'undefined' && offer != null) {
        create_chart(offer, 'chart-area')
    }

    if (typeof offerb !== 'undefined' && offerb != null) {
        create_chart(offerb, 'chart-areab')
    }

    $(".selectable:not(.no-events)").on("click",function () {
        $(".selectable").children(".triangle").addClass("is-hidden");
        $(this).children(".triangle").removeClass("is-hidden");
    })

    $(".selectable:not(.no-events)").on("turbolinks:click",function () {
        $(".selectable").children(".triangle").addClass("is-hidden");
        $(this).children(".triangle").removeClass("is-hidden");
    })

    $(".faq").on("click", function () {
        $(this).next().toggleClass("is-hidden");
    })

    $(".action-email").on("click", function () {
        $('.email-form').toggleClass("is-hidden");
    })

    $(".send-mail").on("click", function () {
        $('#mail-sent').removeClass("is-hidden");
        $(".email-form").addClass("is-hidden")
    })

    $("#mail-sent button").on("click", function () {
        $("#mail-sent").addClass("is-hidden");
    })

    $('.action-print').on("click", function (evt) {
        window.print();
        evt.preventDefault();
        return false;
    })

    $('.env-impact').on("click", function () {
        $('.impact-content').removeClass("is-hidden");
        $('.mix-content').addClass("is-hidden");
        $('.mix-energy').addClass("unselected");
        $('.env-impact').removeClass("unselected");
    })

    $('.mix-energy').on("click", function () {
        $('.impact-content').addClass("is-hidden");
        $('.mix-content').removeClass("is-hidden");
        $('.mix-energy').removeClass("unselected");
        $('.env-impact').addClass("unselected");
    })

    $('.dropdown').on("click", function () {
        $(this).toggleClass('is-active');
    })

    $("input[name=watts]").on("keydown", function () {
        $("button[type=submit]").removeClass("is-hidden");
    })

    if ($("#carousel > .slider").length > 0){
        var str = "";
        $("div.column.mobile-inline").each(function(key, element){ str += element.outerHTML })
        $("#carousel").html(str);
    }

    window.carousels = bulmaCarousel.attach('#carousel', {
        slidesToScroll: 1,
        slidesToShow: 4,
        index: 0,
    });
    
    $(".link-button").on("click",function (){
        var carousel = window.carousels[0];

        if (carousel != null) {
            carousel.show(parseInt($(this).data("index")), true);
        }
    })

    $(".help-button").on("click",function() {
        $(this).parent().find(".help-info").toggleClass("is-hidden");
    })

    $(".help-info button").on("click", function (){
        $(this).parent().parent().addClass("is-hidden");
    })

    $("#lang-menu").on("click", function(){
        $(this).parent().find("#moreDropdown").toggleClass("is-hidden")
    })

    $('.notification .delete').on("click", function(){
        var notification_div = this.parentNode;
        notification_div.parentNode.removeChild(notification_div);
    })

    $('.resize-text').on("click", function(){
        var size = this.val("size");
        resizeText(size);
    })

     // Check for click events on the navbar burger icon
    $(".navbar-burger").click(function() {
        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        $(".navbar-burger").toggleClass("is-active");
        $(".navbar-menu").toggleClass("is-active");
    });
}

var content = null;
var resizeCanvas = function (event) {

    if (content == null) {
        content = $("#content")[0];
        if (content == null) {
            return false;
        }
    }

    var chart_ids = Object.keys(Chart.instances);
    var first_id = chart_ids[0];

    if (first_id == null || Chart.instances[first_id] == null) {
        return false;
    }

    var chart_width = parseInt(Chart.instances[first_id].canvas.style.width);
    var ideal_width = content.offsetWidth / 2 ;

    if (chart_width > ideal_width) {
        for (var id in Chart.instances) {
            Chart.instances[id].canvas.style.width = ideal_width + "px";
            Chart.instances[id].resize();
        }
    }
}


window.onbeforeprint = beforePrint

document.addEventListener("load", bootInit)
window.addEventListener("resize", resizeCanvas)
document.addEventListener("turbolinks:load", bootInit)
